import { createTheme } from '@mui/material/styles';
import { pastel } from './palette';

// Create a MUI theme and expose the pastel palette under palette.custom
const theme = createTheme({
  palette: {
    primary: {
      main: pastel.primaryColor
    },
    background: {
      default: pastel.surfaceLight,
      paper: '#ffffff'
    },
    // custom contains the pastel tokens for use in sx: theme => theme.palette.custom.xxx
    custom: {
      ...pastel
    }
  },
  shape: {
    borderRadius: 14
  },
  components: {
    // small default adjustments (optional)
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 14
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 14
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 18
        }
      }
    }
  }
});

export default theme;